import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: null,
  tracking: null
}

export const serviceDetailAction = createSlice({
  name: 'serviceDetail',
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload
    },
    setTracking: (state, action) => {
      state.tracking = action.payload
    },
  },
})

export const { setData ,setTracking} = serviceDetailAction.actions

export default serviceDetailAction.reducer